import styled from "styled-components";

export const Container = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: 8px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  overflow: hidden;
`;

export const Element = styled.input`
  direction: rtl;
  outline: none;
  border: none;
  box-sizing: border-box;
  ::placeholder {
    color: #27548c;
    opacity: 1;
  }
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  text-align: right;
  width: 100%;
  height: 100%;
  resize: vertical;
  overflow: scroll;
`;

export const LabelContainer = styled.div`
  direction: rtl;
`;

export const IconContainer = styled.div`
  width: 10%;
  height: 95%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;
